import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, Newspaper, FileEdit, Users } from "lucide-react";
import { api } from "@/lib/api";

const CARDS = [
  { key: "enquiries_new", label: "New submissions", icon: Inbox, to: "/admin/submissions", accent: "text-amber-600" },
  { key: "enquiries_total", label: "Total submissions", icon: Inbox, to: "/admin/submissions", accent: "text-azeka-navy" },
  { key: "insights_published", label: "Published insights", icon: Newspaper, to: "/admin/insights", accent: "text-emerald-600" },
  { key: "insights_draft", label: "Draft insights", icon: FileEdit, to: "/admin/insights", accent: "text-slate-600" },
  { key: "users", label: "Admin users", icon: Users, to: "/admin/users", accent: "text-azeka-teal" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/api/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-dashboard">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">Dashboard</h1>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {CARDS.map(({ key, label, icon: Icon, to, accent }) => (
          <Link key={key} to={to} className="rounded-xl border border-slate-200 bg-white p-5 transition-shadow hover:shadow-md">
            <Icon className={`h-6 w-6 ${accent}`} />
            <p className="mt-4 text-3xl font-bold text-ink-heading" data-testid={`stat-${key}`}>{stats[key] ?? "—"}</p>
            <p className="mt-1 text-sm text-ink-muted">{label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
